import React from "react";

const FeedbackSuccess = () => {
  return (
    <div className="h-screen flex items-center justify-center">
      <div className="text-center">
        <h2 className="text-2xl font-bold mb-4">
          🎉 Feedback Submitted
        </h2>
        <p className="text-gray-600">
          Thank you for your feedback!
        </p>
      </div>
    </div>
  );
};

export default FeedbackSuccess;